<template>
  <b-container fluid>
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <esg-base-card v-show="!loading"
                   title="공급망 평가"
                   :footer="false">
      <template #default>
        <b-container class="my-4 px-0">
          <b-row align-h="start">
            <b-col md="6"
                   lg="3"
                   class="mt-3 mt-lg-0">
              <esg-single-score-card title="Leader"
                                     :score="138"
                                     score-unit="사"/>
            </b-col>
            <b-col md="6"
                   lg="3"
                   class="mt-3 mt-lg-0">
              <esg-single-score-card title="Average"
                                     :score="55"
                                     score-unit="사"/>
            </b-col>
            <b-col md="6"
                   lg="3"
                   class="mt-3 mt-lg-0">
              <esg-single-score-card title="Laggard"
                                     :score="56"
                                     score-unit="사"/>
            </b-col>
            <b-col md="6"
                   lg="3"
                   class="mt-3 mt-md-0">
              <esg-single-score-card title="평가완료"
                                     score="30/249"
                                     score-unit="사"/>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <esg-partner-assessment-mgmt-grid :gridId="0"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card id="tab-card"
                      class="border mt-3 mb-3"
                      style="box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;">
                <b-tabs fill>
                  <b-tab>
                    <template #title>
                      <strong><b>종합평가</b></strong>
                    </template>
                    <b-row>
                      <b-col md="5">
                        <esg-base-chart>
                          <ct00041 :data="rawData.filter(obj=>obj.year==='2023').map(obj=>obj.overallAssessment)"/>
                        </esg-base-chart>
                      </b-col>
                      <b-col md="7"
                             class="mt-3 mt-md-0">
                        <ct00042 :data="rawData.map(obj=>({
                              year: obj.year,
                              target: obj.environment,
                            }))"/>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab>
                    <template #title>
                      상세 평가_환경
                    </template>
                    <b-form-row>
                      <b-col cols="5">
                        <esg-base-chart>
                          <ct00041 :data="rawData.filter(obj=>obj.year==='2023').map(obj=>obj.environment)"/>
                        </esg-base-chart>
                      </b-col>
                      <b-col cols="7">
                        <ct00042 :data="rawData.map(obj=>{
                          return {
                              year: obj.year,
                              target: obj.environment,
                            };
                        }
                        )"/>
                      </b-col>
                    </b-form-row>
                  </b-tab>
                  <b-tab>
                    <template #title>
                      상세 평가_안전
                    </template>
                    <b-form-row>
                      <b-col cols="5">
                        <esg-base-chart>
                          <ct00041 :data="rawData.filter(obj=>obj.year==='2023').map(obj=>obj.safety)"/>
                        </esg-base-chart>
                      </b-col>
                      <b-col cols="7">
                        <ct00042 :data="rawData.map(obj=>{
                          return {
                              year: obj.year,
                              target: obj.safety,
                            };
                        }
                        )"/>
                      </b-col>
                    </b-form-row>
                  </b-tab>
                  <b-tab>
                    <template #title>
                      상세 평가_사회
                    </template>
                    <b-form-row>
                      <b-col cols="5">
                        <esg-base-chart>
                          <ct00041 :data="rawData.filter(obj=>obj.year==='2023').map(obj=>obj.society)"/>
                        </esg-base-chart>
                      </b-col>
                      <b-col cols="7">
                        <ct00042 :data="rawData.map(obj=>{
                          return {
                              year: obj.year,
                              target: obj.society,
                            };
                        }
                        )"/>
                      </b-col>
                    </b-form-row>
                  </b-tab>
                  <b-tab>
                    <template #title>
                      상세 평가_윤리
                    </template>
                    <b-form-row>
                      <b-col cols="5">
                        <esg-base-chart>
                          <ct00041 :data="rawData.filter(obj=>obj.year==='2023').map(obj=>obj.ethic)"/>
                        </esg-base-chart>
                      </b-col>
                      <b-col cols="7">
                        <ct00042 :data="rawData.map(obj=>{
                          return {
                              year: obj.year,
                              target: obj.ethic,
                            };
                        }
                        )"/>
                      </b-col>
                    </b-form-row>
                  </b-tab>
                  <b-tab>
                    <template #title>
                      상세 평가_경제
                    </template>
                    <b-form-row>
                      <b-col cols="5">
                        <esg-base-chart>
                          <ct00041 :data="rawData.filter(obj=>obj.year==='2023').map(obj=>obj.economy)"/>
                        </esg-base-chart>
                      </b-col>
                      <b-col cols="7">
                        <ct00042 :data="rawData.map(obj=>{
                          return {
                              year: obj.year,
                              target: obj.economy,
                            };
                        }
                        )"/>
                      </b-col>
                    </b-form-row>
                  </b-tab>
                  <b-tab>
                    <template #title>
                      상세 평가_경영시스템
                    </template>
                    <b-form-row>
                      <b-col cols="5">
                        <esg-base-chart>
                          <ct00041 :data="rawData.filter(obj=>obj.year==='2023').map(obj=>obj.managementSystem)"/>
                        </esg-base-chart>
                      </b-col>
                      <b-col cols="7">
                        <ct00042 :data="rawData.map(obj=>{
                          return {
                              year: obj.year,
                              target: obj.managementSystem,
                            };
                        }
                        )"/>
                      </b-col>
                    </b-form-row>
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </esg-base-card>
  </b-container>
</template>
<script>
import EsgCardHeader from "@/components/esg/base/EsgBaseCardHeader.vue";
import EsgPartnerAssessmentMgmtGrid from "./EsgPartnerAssessmentMgmtGrid.vue"
import EsgSingleScoreCard from "@/components/esg/base/EsgSingleScoreCard.vue";
import ct00041 from '../../charts/ct00041.vue'
import ct00042 from '../../charts/ct00042.vue'
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgBaseCard from "@/components/esg/base/EsgBaseCard.vue";
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  name: 'EsgPartnerCorpMonitoring',
  components: {
    EsgBaseChart,
    EsgBaseCard,
    EsgBaseDashboardCard,
    EsgCardHeader,
    EsgPartnerAssessmentMgmtGrid,
    EsgSingleScoreCard,
    ct00041,
    ct00042
  },
  created() {
    // 더미 데이터 생성
    let i = 0;
    while (this.rawData.length < 249 * 5) {
      this.rawData.push(this.rawData[i++])
    }
    let currentYearData = this.rawData.filter(obj => obj.year === '2023');

    // 2023년도 평가사 수를 249개로 조정
    this.rawData = [...this.rawData.filter(obj => obj.year !== '2023'), ...currentYearData.slice(0, 249)];
  },
  data() {
    return {
      loading: false,
      rawData:
          [
            {
              id: "2023-001",
              year: '2023',
              corpName: "EY 컨설팅",
              businessLocation: "울산 고무공장",
              overallAssessment: "Laggard",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2023-002",
              year: '2023',
              corpName: "EY 한영",
              businessLocation: "당진 고무공장",
              overallAssessment: "Laggard",
              environment: "Average",
              safety: "Average",
              society: "Leader",
              ethic: "Leader",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2023-003",
              year: '2023',
              corpName: "EY 세무",
              businessLocation: "울산 고무공장",
              overallAssessment: "Leader",
              environment: "Laggard",
              safety: "Average",
              society: "Leader",
              ethic: "Leader",
              economy: "Average",
              managementSystem: "Average"
            },
            {
              id: "2023-004",
              year: '2023',
              corpName: "EY 기계",
              businessLocation: "당진 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Average"
            },
            {
              id: "2023-005",
              year: '2023',
              corpName: "EY 정공",
              businessLocation: "당진 고무공장",
              overallAssessment: "Average",
              environment: "Leader",
              safety: "Leader",
              society: "Average",
              ethic: "Average",
              economy: "Laggard",
              managementSystem: "Leader"
            },
            {
              id: "2023-006",
              year: '2023',
              corpName: "EY 운송",
              businessLocation: "당진 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Average",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2023-007",
              year: '2023',
              corpName: "EY 정밀",
              businessLocation: "당진 고무공장",
              overallAssessment: "Average",
              environment: "Average",
              safety: "Laggard",
              society: "Average",
              ethic: "Average",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2023-008",
              year: '2023',
              corpName: "EY 오토웤스",
              businessLocation: "당진 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Laggard",
              society: "Laggard",
              ethic: "Laggard",
              economy: "Leader",
              managementSystem: "Laggard"
            },
            {
              id: "2023-009",
              year: '2023',
              corpName: "EY 법무",
              businessLocation: "당진 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2022-001",
              year: '2022',
              corpName: "EY 컨설팅",
              businessLocation: "울산 고무공장",
              overallAssessment: "Average",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2022-002",
              year: '2022',
              corpName: "EY 한영",
              businessLocation: "당진 고무공장",
              overallAssessment: "Leader",
              environment: "Leader",
              safety: "Leader",
              society: "Leader",
              ethic: "Leader",
              economy: "Leader",
              managementSystem: "Leader"
            },
            {
              id: "2022-003",
              year: '2022',
              corpName: "EY 세무",
              businessLocation: "울산 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Average"
            },
            {
              id: "2022-004",
              year: '2022',
              corpName: "EY 기계",
              businessLocation: "당진 고무공장",
              overallAssessment: "Leader",
              environment: "Laggard",
              safety: "Laggard",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2022-005",
              year: '2022',
              corpName: "EY 정공",
              businessLocation: "당진 고무공장",
              overallAssessment: "Average",
              environment: "Leader",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2022-006",
              year: '2022',
              corpName: "EY 운송",
              businessLocation: "당진 고무공장",
              overallAssessment: "Laggard",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2022-007",
              year: '2022',
              corpName: "EY 정밀",
              businessLocation: "당진 고무공장",
              overallAssessment: "Laggard",
              environment: "Average",
              safety: "Laggard",
              society: "Average",
              ethic: "Leader",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2022-008",
              year: '2022',
              corpName: "EY 오토웤스",
              businessLocation: "당진 고무공장",
              overallAssessment: "Laggard",
              environment: "Average",
              safety: "Laggard",
              society: "Laggard",
              ethic: "Laggard",
              economy: "Leader",
              managementSystem: "Laggard"
            },
            {
              id: "2022-009",
              year: '2022',
              corpName: "EY 법무",
              businessLocation: "당진 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            //
            {
              id: "2021-001",
              year: '2021',
              corpName: "EY 컨설팅",
              businessLocation: "울산 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2021-002",
              year: '2021',
              corpName: "EY 한영",
              businessLocation: "당진 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2021-003",
              year: '2021',
              corpName: "EY 세무",
              businessLocation: "울산 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2021-004",
              year: '2021',
              corpName: "EY 기계",
              businessLocation: "당진 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2021-005",
              year: '2021',
              corpName: "EY 정공",
              businessLocation: "당진 고무공장",
              overallAssessment: "Average",
              environment: "Leader",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2021-006",
              year: '2021',
              corpName: "EY 운송",
              businessLocation: "당진 고무공장",
              overallAssessment: "Laggard",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2021-007",
              year: '2021',
              corpName: "EY 정밀",
              businessLocation: "당진 고무공장",
              overallAssessment: "Average",
              environment: "Average",
              safety: "Laggard",
              society: "Average",
              ethic: "Leader",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2021-008",
              year: '2021',
              corpName: "EY 오토웤스",
              businessLocation: "당진 고무공장",
              overallAssessment: "Laggard",
              environment: "Average",
              safety: "Laggard",
              society: "Laggard",
              ethic: "Laggard",
              economy: "Leader",
              managementSystem: "Laggard"
            },
            {
              id: "2021-009",
              year: '2021',
              corpName: "EY 법무",
              businessLocation: "당진 고무공장",
              overallAssessment: "Laggard",
              environment: "Leader",
              safety: "Laggard",
              society: "Leader",
              ethic: "Laggard",
              economy: "Laggard",
              managementSystem: "Average"
            },
            //
            {
              id: "2020-001",
              year: '2020',
              corpName: "EY 컨설팅",
              businessLocation: "울산 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2020-002",
              year: '2020',
              corpName: "EY 한영",
              businessLocation: "당진 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2020-003",
              year: '2020',
              corpName: "EY 세무",
              businessLocation: "울산 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2020-004",
              year: '2020',
              corpName: "EY 기계",
              businessLocation: "당진 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2020-005",
              year: '2020',
              corpName: "EY 정공",
              businessLocation: "당진 고무공장",
              overallAssessment: "Average",
              environment: "Leader",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2020-006",
              year: '2020',
              corpName: "EY 운송",
              businessLocation: "당진 고무공장",
              overallAssessment: "Laggard",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2020-007",
              year: '2020',
              corpName: "EY 정밀",
              businessLocation: "당진 고무공장",
              overallAssessment: "Average",
              environment: "Average",
              safety: "Laggard",
              society: "Average",
              ethic: "Leader",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2020-008",
              year: '2020',
              corpName: "EY 오토웤스",
              businessLocation: "당진 고무공장",
              overallAssessment: "Laggard",
              environment: "Average",
              safety: "Laggard",
              society: "Laggard",
              ethic: "Laggard",
              economy: "Leader",
              managementSystem: "Laggard"
            },
            {
              id: "2020-009",
              year: '2020',
              corpName: "EY 법무",
              businessLocation: "당진 고무공장",
              overallAssessment: "Laggard",
              environment: "Leader",
              safety: "Laggard",
              society: "Leader",
              ethic: "Laggard",
              economy: "Laggard",
              managementSystem: "Average"
            },
            //
            {
              id: "2019-001",
              year: '2019',
              corpName: "EY 컨설팅",
              businessLocation: "울산 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2019-002",
              year: '2019',
              corpName: "EY 한영",
              businessLocation: "당진 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2019-003",
              year: '2019',
              corpName: "EY 세무",
              businessLocation: "울산 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2019-004",
              year: '2019',
              corpName: "EY 기계",
              businessLocation: "당진 고무공장",
              overallAssessment: "Leader",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2019-005",
              year: '2019',
              corpName: "EY 정공",
              businessLocation: "당진 고무공장",
              overallAssessment: "Average",
              environment: "Leader",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2019-006",
              year: '2019',
              corpName: "EY 운송",
              businessLocation: "당진 고무공장",
              overallAssessment: "Laggard",
              environment: "Average",
              safety: "Average",
              society: "Average",
              ethic: "Laggard",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2019-007",
              year: '2019',
              corpName: "EY 정밀",
              businessLocation: "당진 고무공장",
              overallAssessment: "Average",
              environment: "Average",
              safety: "Laggard",
              society: "Average",
              ethic: "Leader",
              economy: "Average",
              managementSystem: "Laggard"
            },
            {
              id: "2019-008",
              year: '2019',
              corpName: "EY 오토웤스",
              businessLocation: "당진 고무공장",
              overallAssessment: "Laggard",
              environment: "Average",
              safety: "Laggard",
              society: "Laggard",
              ethic: "Laggard",
              economy: "Leader",
              managementSystem: "Laggard"
            },
            {
              id: "2019-009",
              year: '2019',
              corpName: "EY 법무",
              businessLocation: "당진 고무공장",
              overallAssessment: "Laggard",
              environment: "Leader",
              safety: "Laggard",
              society: "Leader",
              ethic: "Laggard",
              economy: "Laggard",
              managementSystem: "Average"
            },
          ]
    }
  }
}
</script>
<style>
#EsgPartnerCorpMonitoringProgressManagement h1 {
  color: black;
  font-family: bold;
}

#EsgPartnerCorpMonitoringProgressManagement .card .card-body {
  padding: 0px;
}

#EsgPartnerCorpMonitoringProgressManagement .tab-content {
  padding: 15px;
}
</style>